import React, { useEffect } from "react";
import AntTable from "../../components/AntTableV2";

export default function ProductTabV2(props) {
  const ProductColumns = [
    {
      title: "Sno",
      align: "center",
      field: "Channel",
      width: 60,
      render: (record, rowIndex) => rowIndex,
    },
    {
      title: "Channel",
      align: "center",
      field: "Channel",
      width: 75,
      render: (record, rowIndex) =>
        record.Channel === "Amazon-India" ? (
          <div className="amazon-logo-small"></div>
        ) : record.Channel === "Flipkart" ? (
          <div className="flipkart-logo-small"></div>
        ) : (
          "-"
        ),
      isFilterable: true,
      type: "string",
    },
    // {
    //   title: "Image",
    //   align: "center",
    //   field: "SKU",
    //   width: 60,
    //   render: (record, rowIndex) => {
    //     return (
    //       <Image
    //         style={{
    //           height: 36,
    //           width: 36,
    //           objectFit: "cover",
    //           border: "1px solid #EAE6FF",
    //         }}
    //         src={record.ImageURL}
    //         fallback="data:image/png;base64,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"
    //       />
    //     );
    //   },
    // },
    {
      title: "SKU",
      align: "center",
      field: "SKU",
      isFilterable: true,
      type: "string",
      defaultSortOrder: "descend",
      width: 150,
      render: (record, rowIndex) => (
        <div>
          {record.SKU}
        </div>
      ),
      sorter: (a, b) => {
        a = (a.SKU || "").toLowerCase();
        b = (b.SKU || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "SKU Quantity",
      align: "center",
      field: "QuantityShippedSum",
      isFilterable: true,
      type: "number",
      isTotal: true,
      isNegative : false,
      isDecimal: true,
      total: props.profitTotal?.Total_qty,
      width: 80,
      render: (record, rowIndex) => (
        <div>
          {record.QuantityShippedSum
            ? record.QuantityShippedSum.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
              currency: "INR",
            })
            : "-"}
        </div>
      ),
      sorter: (a, b) => {
        a = (a || {}).QuantityShippedSum || 0;
        b = (b || {}).QuantityShippedSum || 0;
        return a - b;
      },

      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Invoice Price",
      align: "center",
      field: "InvoicePriceTotalSum",
      width: 90,
      isFilterable: true,
      isTotal: true,
      isTotalCurrency: true,
      total: props.profitTotal?.Total_invoice,
      type: "number",
      render: (record, rowIndex) => (
        <div>
          {record.InvoicePriceTotalSum
            ? record.InvoicePriceTotalSum.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
              style: "currency",
              currency: "INR",
            })
            : "-"}
        </div>
      ),
      sorter: (a, b) => {
        a = (a || {}).InvoicePriceTotalSum || 0;
        b = (b || {}).InvoicePriceTotalSum || 0;
        return a - b;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Product Cost",
      align: "center",
      field: "CostPerOrderSum",
      width: 80,
      isTotal: true,
      isTotalCurrency: true,
      // isNegative :false,
      total:props.profitTotal?.Total_cost_per,
      isFilterable: true,
      type: "number",
      render: (record, rowIndex) => (
        <div>
          {record.CostPerOrderSum
            ? record.CostPerOrderSum.toLocaleString("en-IN", {
              maximumFractionDigits: 0,
              style: "currency",
              currency: "INR",
            })
            : "-"}
        </div>
      ),
      sorter: (a, b) => {
        a = (a || {}).CostPerOrderSum || 0;
        b = (b || {}).CostPerOrderSum || 0;
        return a - b;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Market Place Fees",
      align: "center",
      field: "MarketplaceFeesTotalSum",
      width: 80,
      isFilterable: true,
      isTotal: true,
      isTotalCurrency: true,
      type: "number",
      total: props.profitTotal?.Total_market,
      render: (record, rowIndex) => (
        <div>
          {record.MarketplaceFeesTotalSum
            ? record.MarketplaceFeesTotalSum.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
              style: "currency",
              currency: "INR",
            })
            : "-"}
        </div>
      ),
      sorter: (a, b) => {
        a = (a || {}).MarketplaceFeesTotalSum || 0;
        b = (b || {}).MarketplaceFeesTotalSum || 0;
        return a - b;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Shipping Fees",
      align: "center",
      field: "ShippingFeesTotalSum",
      width: 80,
      isFilterable: true,
      isTotal: true,
      isTotalCurrency: true,
      type: "number",
      total: props.profitTotal?.Total_shipping,
      render: (record, rowIndex) => (
        <div>
          {record.ShippingFeesTotalSum
            ? record.ShippingFeesTotalSum.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
              style: "currency",
              currency: "INR",
            })
            : "-"}
        </div>
      ),
      sorter: (a, b) => {
        a = (a || {}).ShippingFeesTotalSum || 0;
        b = (b || {}).ShippingFeesTotalSum || 0;
        return a - b;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Ad Spend",
      align: "center",
      field: "AdsSpentSum",
      isFilterable: true,
      width: 80,
      isTotal: true,
      type: "number",
      total: Number(props.profitTotal?.Total_ads),
      isTotalCurrency: true,
      sorter: (a, b) => {
        a = (a || {}).AdsSpentSum || 0;
        b = (b || {}).AdsSpentSum || 0;
        return a - b;
      },
      render: (record, rowIndex) => (
        <div>
          {record.AdsSpentSum
            ? record.AdsSpentSum.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
              style: "currency",
              currency: "INR",
            })
            : "-"}
        </div>
      ),
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Return Cost",
      align: "center",
      field: "ReturnPriceTotalSum",
      width: 80,
      isFilterable: true,
      isTotal: true,
      isTotalCurrency: true,
      type: "number",
      total: props.profitTotal?.Total_return,
      render: (record, rowIndex) => (
        <div>
          {record.ReturnPriceTotalSum
            ? record.ReturnPriceTotalSum.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
              style: "currency",
              currency: "INR",
            })
            : "-"}
        </div>
      ),
      sorter: (a, b) => {
        a = (a || {}).ReturnPriceTotalSum || 0;
        b = (b || {}).ReturnPriceTotalSum || 0;
        return a - b;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    ...((props.taxValue === "With Tax" && [
      {
        title: "GST OUT",
        align: "center",
        field: "OUTGST",
        isTotal: true,
        isTotalCurrency: true,
        width: 80,
        total: props.profitTotal?.Total_OUTGST,
        render: (record, rowIndex, isLoading) =>
          isLoading ? (
            <div className="item">
              <div className="item-title" />
            </div>
          ) : record.OUTGST ? (
            record.OUTGST.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
              style: "currency",
              currency: "INR",
            })
          ) : (
            "-"
          ),
        sorter: (a, b) => {
          a = a.Out_gst || 0;
          b = b.Out_gst || 0;
          return a - b;
        },
        sortDirections: ["descend", "ascend", "descend"],
      },
      {
        title: "GST IN",
        align: "center",
        field: "InGst",
        isTotal: true,
        isTotalCurrency: true,
        width: 80,
        total: props.profitTotal?.Total_InGst,
        render: (record, rowIndex, isLoading) =>
          isLoading ? (
            <div className="item">
              <div className="item-title" />
            </div>
          ) : record.InGst ? (
            record.InGst.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
              style: "currency",
              currency: "INR",
            })
          ) : (
            "-"
          ),
        sorter: (a, b) => {
          a = a.InGst || 0;
          b = b.InGst || 0;
          return a - b;
        },
        sortDirections: ["descend", "ascend", "descend"],
      },
    ]) || []),
    {
      title: "Profit",
      align: "center",
      field: "Profit",
      width: 80,
      isFilterable: true,
      isTotal: true,
      isTotalCurrency: true,
      type: "number",
      total: props.profitTotal?.Total_profit,
      render: (record, rowIndex) => (
        <div>
          {record.Profit
            ? record.Profit.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
              style: "currency",
              currency: "INR",
            })
            : "-"}
        </div>
      ),
      sorter: (a, b) => {
        a = (a || {}).Profit || 0;
        b = (b || {}).Profit || 0;
        return a - b;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Profit Margin",
      align: "center",
      field: "ProfitMargin",
      width: 80,
      isFilterable: true,
      isTotal: true,
      type: "number",
      isPercent : true,
      total: props.profitTotal?.Total_margin,
      sorter: (a, b) => {
        a = (a || {}).ProfitMargin || 0;
        b = (b || {}).ProfitMargin || 0;
        return a - b;
      },
      render: (record, rowIndex) =>
      (
        <div>
          {record.ProfitMargin
            ? record.ProfitMargin.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
              currency: "INR",
            }) + "%"
            : "-"}
        </div>
      ),
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "TACOS",
      align: "center",
      field: "ACOTS",
      width: 80,
      isFilterable: true,
      isTotal: true,
      type: "number",
      isPercent : true,
      total: (props.profitTotal?.Total_ACOTS) * -1,
      sorter: (a, b) => {
        a = (a || {}).ACOTS || 0;
        b = (b || {}).ACOTS || 0;
        return a - b;
      },
      render: (record, rowIndex, isLoading) =>
        isLoading ? (
          <div className="item">
            <div className="item-title" />
          </div>
        ) : record.ACOTS ? (
          record.ACOTS.toLocaleString("en-IN", {
            maximumFractionDigits: 2,
            currency: "INR",
          }) + "%"
        ) : (
          "-"
        ),
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: 'ROI',
      align: "center",
      field: "ROI",
      width: 80,
      isFilterable: true,
      isTotal: true,
      // isTotalCurrency: true,
      type: "number",
      isPercent : true,
      total: (props.profitTotal?.Total_ROI) * -1,
      sorter: (a, b) => {
        a = (a || {}).ROI || 0;
        b = (b || {}).ROI || 0;
        return a - b;
      },
      render: (record, rowIndex, isLoading) =>
        isLoading ? (
          <div className="item">
            <div className="item-title" />
          </div>
        ) : record.ROI ? (
          (record.ROI * 100).toLocaleString("en-IN", {
            maximumFractionDigits: 2,
            // style: "currency",
            currency: "INR",
          }) + "%"
        ) : (
          "-"
        ),
      sortDirections: ["descend", "ascend", "descend"],
    },
  ];
  const onTableChange = async ({
    paginationCondition,
    sortCondition,
    filterCondition,
  }) => {
    props.tableFilterData(paginationCondition, sortCondition, filterCondition);
  };
  useEffect(() => {
    if (props.activeTab === "0") {
      props.setColumn(ProductColumns);
    }
  }, [props.activeTab, props.taxValue]);

  return (
    <div>
      <AntTable
        columns={ProductColumns}
        dataSource={props.data}
        stickyHeader={{
          offsetHeader: 65,
        }}
        totalRecords={props.pageCount}
        rowKey={(row, rowIndex) => rowIndex}
        isLoading={props.isLoading}
        hideSummary={!props.data?.length}
        searchText={[props.searchText]}
        onDataChange={onTableChange}
      />
    </div>
  );
}
